const addressVerificationOptions = {
  youEntered: 'You entered',
  weRecommend: 'We recommend',
  useThisAddress: 'Use this address',
  editThisAddress: 'Edit this address',
}


export default addressVerificationOptions
